import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "", as = "div" }) => {
  const Tag = motion[as];
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Tag>
  );
};

export const SectionTitle = ({ script, eyebrow, testId, light = false }) => (
  <Reveal className="flex items-center gap-4 sm:gap-8">
    <span className={`h-px flex-1 ${light ? "bg-gold/40" : "bg-gradient-to-r from-transparent to-gold/70"}`} />
    <div className="text-center">
      {eyebrow && <p className={`eyebrow mb-1 ${light ? "text-gold-light" : "text-gold-deep"}`}>{eyebrow}</p>}
      <h2 data-testid={testId} className={`font-script text-5xl sm:text-6xl lg:text-7xl leading-[1.15] ${light ? "text-cream" : "text-plum"}`}>
        {script}
      </h2>
    </div>
    <span className={`h-px flex-1 ${light ? "bg-gold/40" : "bg-gradient-to-l from-transparent to-gold/70"}`} />
  </Reveal>
);
